import { NumberInput } from '~/primitives/input';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { cn } from '~/util';
import { useDisableFormContext } from '../DisableContext';

export function NumberField({
    placeholder,
    classname,
    disabled,
    decimalPlaces,
    ...labelProps
}: {
    placeholder: string;
    classname?: string;
    disabled?: boolean;
    decimalPlaces?: number;
} & FieldWithErrorProps) {
    const field = useFieldContext<number | null>();
    const disabledContext = useDisableFormContext();
    return (
        <FieldLabelWithError<number | null> {...labelProps}>
            <NumberInput
                className={cn('field-sizing-content max-w-lg', classname)}
                id={field.name}
                placeholder={placeholder}
                required={labelProps.required}
                value={field.state.value}
                onChange={field.handleChange}
                disabled={disabled || disabledContext}
                decimalPlaces={decimalPlaces}
            />
        </FieldLabelWithError>
    );
}
